var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"vm-icon-collect afd pointer",class:[_vm.data.has_mark == 1 ? 'on': 'black-3',_vm.data.has_mark == 1 ? 'afd-star-filled' : 'afd-star'],on:{"click":_vm.tap}})}
var staticRenderFns = []

export { render, staticRenderFns }